import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect, useParams } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import AddRoleUser from "./AddRoleUser";
import authorizedComponent from "../../../helpers/authorized-component";
import MobileHelper from "../../../helpers/mobile";
import NumberHelper from "../../../helpers/numbers";
import ConfirmTypeUser from "./ConfirmTypeUser";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import helperSpinner from "../../../helpers/spinner";

function ShowUserInfo() {
  const initobjectInfoUser = {
    firstname: "",
    lastname: "",
    category: "",
    phone: "",
    national_code: "",
    identity_number: "",
    state: "",
    city: "",
    town: "",
    postal_code: "",
    description: "",
    charge: 0,
  };

  const params = useParams();
  const userID = params.id;
  const [userInfo, setUserInfo] = useState(initobjectInfoUser);

  useEffect(() => {
    getUserInfoUseEffect();
  }, []);

  const getUserInfoUseEffect = async () => {
    let userInfo = await getInitInfoUser();
    userInfo = userInfo.data.data;
    if (userInfo !== null) {
      setUserInfo(userInfo);
    }
  };

  const showMarketerRegisterUser = () => {
    return (
      <div>
        <hr />
        <span>شماره کاربر بازاریاب این کاربر : </span>
        <span>{userInfo.marketer_id}</span>
        <span>
          <Link
            className="btn btn-info"
            target="_blank"
            to={`/user/show-info-user/${userInfo.marketer_id}`}
          >
            دیدن اطلاعات کاربر بازاریاب
          </Link>
        </span>
        <hr />
      </div>
    );
  };

  const addUserToUsersRegisteredByMarketer = async () => {
    const marketerID = document.querySelector("#marketer-id").value;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultRequestAddUserToUsersRegisteredByMarketer =
      await sendRequestAddUserToUsersRegisteredByMarketer(userID, marketerID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultRequestAddUserToUsersRegisteredByMarketer) {
      return;
    }
    window.location.reload();
  };

  const sendRequestAddUserToUsersRegisteredByMarketer = async (
    userID,
    marketerID
  ) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/marketer/manage/set-user-registered-by-marketer/${marketerID}/user-id/${userID}`,
        {},
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const showFormAddUserToUsersRegisteredByMarketer = () => {
    return (
      <>
        <div>
          <label>
            اضافه کردن این کاربر در لیست کاربران ثبت نام شده بازاریاب
          </label>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              addUserToUsersRegisteredByMarketer();
            }}
            className="d-flex py-2"
          >
            <div className="pl-2">
              <input
                className="form-control"
                id="marketer-id"
                type="number"
                placeholder="شماره کاربر بازاریاب را وارد کنید."
              />
            </div>
            <div>
              <button className="btn btn-primary">اعمال</button>
            </div>
          </form>
        </div>
        <hr />
      </>
    );
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  };

  const getInitInfoUser = async () => {
    let usersInfo;

    const headersRequest = getHeaderForRequest();
    try {
      usersInfo = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/info-user/" + userID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return usersInfo;
  };
  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">اطلاعات کاربر</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link className="text-white" to="/user/all">
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>

              <div className="table-responsive pt-2">
                <table className="table table-hilite tbl-td-white-space">
                  {" "}
                  <thead>
                    <tr>
                      <td
                        colspan="2"
                        className="text-center"
                        style={{ borderRadius: "25px 25px 0px 0px" }}
                      >
                        اطلاعات کاربر
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>شماره کاربری</td>
                      <td>{userID}</td>
                    </tr>
                    <tr>
                      <td>ایمیل</td>
                      <td>{userInfo.email}</td>
                    </tr>
                    <tr>
                      <td>تایید ایمیل</td>
                      <td>
                        {userInfo.confirm_email ? (
                          <span class="badge badge-success">تایید شده</span>
                        ) : (
                          <span class="badge badge-danger">تایید نشده</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>شماره موبایل</td>
                      <td dir="ltr">
                        {userInfo.mobile
                          ? NumberHelper.toPersianNum(
                              MobileHelper.formatMobile(userInfo.mobile)
                            )
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>تایید موبایل</td>
                      <td>
                        {userInfo.confirm_mobile ? (
                          <span class="badge badge-success">تایید شده</span>
                        ) : (
                          <span class="badge badge-danger">تایید نشده</span>
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td>نام</td>
                      <td>{userInfo.firstname}</td>
                    </tr>
                    <tr>
                      <td>نام خانوادگی</td>
                      <td>{userInfo.lastname}</td>
                    </tr>
                    <tr>
                      <td>نوع کاربر</td>
                      <td>{userInfo.type}</td>
                    </tr>
                    <tr>
                      <td>دسته صنفی</td>
                      <td>{userInfo.category}</td>
                    </tr>
                    <tr>
                      <td>مبلغ شارژ کاربر</td>
                      <td className="letter-spacing-finance-number">
                        {NumberHelper.toPersianNum(
                          NumberHelper.toFormatFinanceNumber(userInfo.charge)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>شماره تلفن</td>
                      <td className="letter-spacing-finance-number">
                        {NumberHelper.toPersianNum(userInfo.phone)}
                      </td>
                    </tr>

                    <tr>
                      <td>شناسه ملی</td>
                      <td className="letter-spacing-finance-number">
                        {NumberHelper.toPersianNum(userInfo.identity_national)}
                      </td>
                    </tr>
                    <tr>
                      <td>شماره اقتصادی</td>
                      <td className="letter-spacing-finance-number">
                        {NumberHelper.toPersianNum(userInfo.economic_number)}
                      </td>
                    </tr>
                    <tr>
                      <td>شماره ثبت</td>
                      <td className="letter-spacing-finance-number">
                        {NumberHelper.toPersianNum(userInfo.register_number)}
                      </td>
                    </tr>

                    <tr>
                      <td>کد ملی</td>
                      <td className="letter-spacing-finance-number">
                        {NumberHelper.toPersianNum(userInfo.national_code)}
                      </td>
                    </tr>
                    <tr>
                      <td>شماره شناسنامه</td>
                      <td className="letter-spacing-finance-number">
                        {NumberHelper.toPersianNum(userInfo.identity_number)}
                      </td>
                    </tr>
                    <tr>
                      <td>استان</td>
                      <td>{userInfo.state}</td>
                    </tr>
                    <tr>
                      <td>شهر</td>
                      <td>{userInfo.city}</td>
                    </tr>
                    <tr>
                      <td>شهرستان</td>
                      <td>{userInfo.town}</td>
                    </tr>
                    <tr>
                      <td>کد پستی</td>
                      <td className="letter-spacing-finance-number">
                        {NumberHelper.toPersianNum(userInfo.postal_code)}
                      </td>
                    </tr>
                    <tr>
                      <td>توضیحات</td>
                      <td>{userInfo.description}</td>
                    </tr>
                    <tr>
                      <td>کد تایید اس ام اس شماره موبایل</td>
                      <td>{userInfo.usr_mobile_confirm_code}</td>
                    </tr>
                  </tbody>
                </table>

                <hr />
                <div className="pt-2">
                  <Link
                    className="btn btn-info"
                    to={`/user/manage/${parseInt(userID)}/note-call`}
                  >
                    نمایش لیست یادداشت های تماس
                  </Link>
                </div>
                <hr />

                {userInfo.marketer_id
                  ? showMarketerRegisterUser()
                  : showFormAddUserToUsersRegisteredByMarketer()}
                {userInfo.coworker_id ? (
                  <div>
                    <span>شماره کاربر همکار این کاربر : </span>
                    <span>{userInfo.coworker_id}</span>
                  </div>
                ) : (
                  ""
                )}
                <span className="pl-2">
                  <Link
                    className="btn btn-info"
                    to={`/user/manage/${parseInt(userID)}/site-advertiser`}
                  >
                    لیست سایت های تبلیغ دهنده کاربر
                  </Link>
                </span>
                <span>
                  <Link
                    className="btn btn-danger"
                    to={`/user/manage/${parseInt(userID)}/site-publisher`}
                  >
                    لیست سایت های نمایش دهنده کاربر
                  </Link>
                </span>
                <hr />
                <AddRoleUser userID={userID} />

                <hr />
                <ConfirmTypeUser
                  userID={userID}
                  confirm_type_info={userInfo.confirm_type_info}
                  reason_ban_info={userInfo.reason_ban_info}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default ShowUserInfo;
